
import { Paper, Typography, Grid, FormLabel, FormControl, Divider, Button, makeStyles, MenuItem, Select, RadioGroup, FormControlLabel, Radio } from "@material-ui/core";
import React, { useContext, useEffect, useState } from "react";
import { createLayerHeatOcorrencias, createLayerOcorrencias } from "./businessLogic";
import { transToSelect } from "./businessLogic";
import { MapOcorrenciasContext } from "./MapaOcorrencias";
import FilterListIcon from '@material-ui/icons/FilterList';
import { useTSelector } from "../../../store/ConfigureStore";
import MultiSelect, { OptionsType } from 'react-select';
import { IOcorrencia } from "../../../store/Models";
import { fetchListaOcorrencias, IQueryParams } from "./effects";
import { useDispatch } from "react-redux";
import { doLeCidadesAction } from "../../../actions/CidadesAction";
import { anos_origin, tipos_planta_origin, especies_origin, /*generos_origin, */ herbicidas_origin, mecanismos_acao_origin, multiplos_mecanismos_origin, respostas_erva_origin } from "./localData";

//export const _ALIAS_DOENCA_SOJA = 'Ferrugem da Soja';
//export const _ALIAS_DOENCA_ALGODDAO = 'Mancha da Ramulária';



const useStyles = makeStyles(theme => ({
    paper: {
        padding: 10,
        margin: 10,
        textAlign: 'left',
        overflow: 'auto',
        maxHeight: 'calc(100vh - 260px)',
        color: theme.palette.text.secondary,
        cursor: 'pointer',
    },
    formulario: {
        overflow: 'hidden'
    },
    formControl: {
        fontSize: 12,
        marginTop:'-5px',
        padding:'-10px',
    },
    button: {
        marginTop: '20px',
        marginBottom: '20px',
    },

}));



export const FormOcorrencias: React.FC = () => {

    const context = useContext(MapOcorrenciasContext);
    const classes = useStyles();
    const dispatch = useDispatch();

   
    const cidades = useTSelector(state => state.cidadeReducer.cidades);
    const estados = useTSelector(state => state.estadoReducer.estados);
    const tipos = tipos_planta_origin;
    //const generos = generos_origin.sort((a, b) => a.label >= b.label ? 1 : -1);
    const herbicidas = herbicidas_origin.sort((a, b) => a.label >= b.label ? 1 : -1);
    const mecanismos_acao = mecanismos_acao_origin.sort((a, b) => a.label >= b.label ? 1 : -1);
    const multiplos_mecanismos = multiplos_mecanismos_origin.sort((a, b) => a.label >= b.label ? 1 : -1);
    const anos = anos_origin.sort((a, b) => a.label >= b.label ? 1 : -1);
    //const especies = especies_origin.sort((a, b) => a.label >= b.label ? 1 : -1);
    const respostas = respostas_erva_origin;

  
    const [cidadesEscolhidas, setCidadesEscolhidas] = useState<OptionsType<any>>([]);
    const [especiesEscolhidas, setEspeciesEscolhidas] = useState<OptionsType<any>>([]);
    const [estadoEscolhido, setEstadoEscolhido] = useState<number>(-1);
    const [tipoEscolhido, setTipoEscolhido] = useState<string>("All");
    //const [generoEscolhido, setGeneroEscolhido] = useState<string>("All");
    const [herbicidaEscolhido, setHerbicidaEscolhido] = useState<string>("All");
    const [mecanismoAcaoEscolhido, setMecanismoAcaoEscolhido] = useState<string>("All");
    const [multiploMecanismoEscolhido, setMultiploMecanismoEscolhido] = useState<string>("All");
    const [anoEscolhido, setAnoEscolhido] = useState<number>(-1);
    //const [especieEscolhida, setEspecieEscolhida] = useState<string>("All");
    const [respostaEscolhida, setRespostaEscolhida] = useState<string>('Resistant');
    const [tipoMapa, setTipoMapa] = useState<string>('point');
    const [especies, setEspecies] = useState<Array<any>> (especies_origin.sort((a, b) => a.label >= b.label ? 1 : -1));

    // efeito a ser aplicado quando mudarem as ocorrencias
    useEffect(() => {

        const exec = async () => {
            // seta a dataInicial e dataFinal baseada no range de ocorrencias
            //const dInicial = context.ocorrencias.reduce((min: IOcorrencia, o: IOcorrencia) => moment(o.dia) <= moment(min.dia) ? o : min);
            //const dFinal = context.ocorrencias.reduce((min: IOcorrencia, o: IOcorrencia) => moment(o.dia) >= moment(min.dia) ? o : min);
         
        }

        context.filterOcorrencias && context.filterOcorrencias.length > 0 && exec();

    }, [context.filterOcorrencias]);


    const comboEstados = estados.map(e => {
        return (
            <MenuItem key={e.id} value={e.id}>
                {e.nome}
            </MenuItem>
        );
    });

    const comboTiposPlanta = tipos.map(tp => {
        return (
            <MenuItem key={tp.value} value={tp.value}>
                {tp.label}
            </MenuItem>
        );
    });
/*
    const comboGeneros = generos.map(g => {
        return (
            <MenuItem key={g.value} value={g.value}>
                {g.label}
            </MenuItem>
        );
    });*/
    const comboHerbicidas = herbicidas.map(h => {
        return (
            <MenuItem key={h.value} value={h.value}>
                {h.label}
            </MenuItem>
        );
    });

    const comboMecanismosAcao = mecanismos_acao.map(m => {
        return (
            <MenuItem key={m.value} value={m.value}>
                {m.label}
            </MenuItem>
        );
    });

    const comboMultiplosMecanismos = multiplos_mecanismos.map(mm => {
        return (
            <MenuItem key={mm.value} value={mm.value}>
                {mm.label}
            </MenuItem>
        );
    });

    const comboAnos = anos.map(an => {
        return (
            <MenuItem key={an.value} value={an.value}>
               {an.label}
            </MenuItem>
        );
    });
/*
    const comboEspecies = especies.map(ep => {
        return (
            <MenuItem key={ep.value} value={ep.value}>
               {ep.label}
            </MenuItem>
        );
    });
*/
    const comboRespostas = respostas.map(re => {
        return (
            <MenuItem key={re.value} value={re.value}>
               {re.label}
            </MenuItem>
        );
    });
    
    const filtrarCidades = (idEstado:number) => {
        dispatch(doLeCidadesAction(idEstado));
    }

    const filtrarEspecies = (tipo:string) => {
        if (tipo === "All"){
           setEspecies(especies_origin.sort((a, b) => a.label >= b.label ? 1 : -1));
        }else{
            if (tipo === "Grass"){
                setEspecies((especies_origin.filter(e => e.type === 1)).sort((a, b) => a.label >= b.label ? 1 : -1));
            }else{
                setEspecies((especies_origin.filter(e => e.type === 2)).sort((a, b) => a.label >= b.label ? 1 : -1));
            }

        }  
    }

    const limparMecanismoAcao = (resposta:string) => {
        if(resposta !== 'Resistant')
            setMecanismoAcaoEscolhido("All")
    }
    
    const handleChange = (event: any) => {
        const { target: { value: _value } } = event;
        setTipoMapa(_value);
    }

    const preparaDadosEspeciesConsulta = () =>{
        let especiesTemp: Array<string> = [];
        if (especiesEscolhidas.length !== 0) {
            for (let i = 0; i < especiesEscolhidas.length; i++)
            especiesTemp[i] = especiesEscolhidas[i].value;
        }
        return especiesTemp;
    }

    const aplicarConsulta = async () => {
        let cidades: Array<Number> = [];
        if (cidadesEscolhidas.length !== 0){
            for (let i =0; i < cidadesEscolhidas.length; i++)
                cidades[i] = cidadesEscolhidas[i].value;
    }

        const parametros: IQueryParams = {
            weed: (tipoEscolhido === "All"? undefined: tipoEscolhido),
            year: (anoEscolhido === -1? undefined: anoEscolhido),
            //genus: (generoEscolhido === "All"? undefined: generoEscolhido),
            genus: undefined,
            species:(especiesEscolhidas.length=== 0 ? undefined : preparaDadosEspeciesConsulta()),
            herbicide: (herbicidaEscolhido === "All"? undefined: herbicidaEscolhido),
            actionMechanism: (mecanismoAcaoEscolhido === "All"? undefined: mecanismoAcaoEscolhido),
            multipleMechanism: (multiploMecanismoEscolhido === "All"? undefined: multiploMecanismoEscolhido),
            cities :(cidadesEscolhidas.length === 0? undefined: cidades),
            state: (estadoEscolhido === -1? undefined: estadoEscolhido),
            weedResponse: (respostaEscolhida === "All"? undefined: respostaEscolhida)
        };
        const ocorrs = await fetchListaOcorrencias(parametros) as Array<IOcorrencia>;
       
        if (tipoMapa === 'point'){
            // @ts-ignore
            createLayerOcorrencias(context.map, ocorrs);
        }
        else {
            // @ts-ignore
            createLayerHeatOcorrencias(context.map, ocorrs);
        }
        context.setFilterOcorrencias(ocorrs);
    }

    return (
        <>
            <Paper className={classes.paper}>

                <div className={classes.formulario}>

                    <Typography variant='button' align='center' paragraph>Opções</Typography>                   
                        <Grid
                            container
                            spacing={1}
                            direction="row"
                            justify="flex-end"
                            alignItems="flex-start"
                        >
                             <Grid item sm={12}>
                                <RadioGroup row aria-label="cultura" onChange={handleChange} name="row-radio-buttons-group">
                                    <FormControlLabel checked={tipoMapa === "point"} value="point" control={<Radio />} label="Mapa de pontos" />
                                    <FormControlLabel value="heat" control={<Radio />} label="Mapa de calor" />    
                                </RadioGroup>
                        </Grid>
                            <Grid item sm={12}>
                                <FormLabel className={classes.formControl} >Ano</FormLabel>
                                <FormControl  margin='dense' fullWidth>
                                    <Select
                                        className={classes.formControl}
                                        labelId={"ano_id"}
                                        variant="outlined"
                                        id={"ano_id"}
                                        value={anoEscolhido}
                                        onChange={(e) => {
                                            e.preventDefault();
                                            const ano = e.target.value as number;
                                            setAnoEscolhido(ano);
                                        }}
                                    >
                                        <MenuItem key={"-1"} value={"-1"}>Todos</MenuItem>
                                        {comboAnos}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item sm={12}>
                                <FormLabel className={classes.formControl} >Tipo de planta</FormLabel>
                                <FormControl margin='dense' fullWidth>
                                    <Select
                                        labelId={"erva_id"}
                                        className={classes.formControl} 
                                        variant="outlined"
                                        id={"erva_id"}
                                        value={tipoEscolhido}
                                        onChange={(e) => {
                                            e.preventDefault();
                                            const tipo = e.target.value as string;
                                            setTipoEscolhido(tipo);
                                            filtrarEspecies(tipo);
                                            setEspeciesEscolhidas([]);
                                        }}
                                    >
                                        <MenuItem key={"All"} value={"All"}>Todas</MenuItem>
                                        {comboTiposPlanta}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item sm={12}>
                                <FormLabel className={classes.formControl}>Tipo de planta daninha</FormLabel>
                                <FormControl margin='dense' fullWidth>
                                    <Select
                                        labelId={"resposta_id"}
                                        className={classes.formControl} 
                                        variant="outlined"
                                        id={"resposta_id"}
                                        value={respostaEscolhida}
                                        onChange={(e) => {
                                            e.preventDefault();
                                            const resposta = e.target.value as string;
                                            setRespostaEscolhida(resposta);
                                            limparMecanismoAcao(resposta);
                                        }}
                                    >
                                        <MenuItem key={"All"} value={"All"}>Todas</MenuItem>
                                        {comboRespostas}
                                    </Select>
                                </FormControl>
                            </Grid>
                            {/*
                                    <Grid item sm={12}>
                                        <FormLabel className={classes.formControl}>Plant genus</FormLabel>
                                        <FormControl margin='dense' fullWidth>
                                            <Select
                                                labelId={"genero_id"}
                                                className={classes.formControl} 
                                                variant="outlined"
                                                id={"genero_id"}
                                                value={generoEscolhido}
                                                onChange={(e) => {
                                                    e.preventDefault();
                                                    const genero = e.target.value as string;
                                                    setGeneroEscolhido(genero)
                                                }}
                                            >
                                                <MenuItem key={"All"} value={"All"}>All genus</MenuItem>
                                                {comboGeneros}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                            */}

                            <Grid item sm={12}>
                                <FormLabel className={classes.formControl} >Espécies</FormLabel>
                                <FormControl margin='dense' fullWidth>
                                    <MultiSelect
                                        className={classes.formControl}
                                        options={transToSelect(especies, 'label', 'value')}
                                        isMulti 
                                        placeholder='Todas'
                                        value={especiesEscolhidas}
                                        onChange={(options: any) => {
                                            setEspeciesEscolhidas(options);
                                        }}
                                    />
                                </FormControl>
                            </Grid>
                            
                           <Grid item sm={12}>
                                <FormLabel className={classes.formControl}>Estado</FormLabel>
                                <FormControl  margin='dense' fullWidth>
                                    <Select
                                        className={classes.formControl}
                                        labelId={"estado_id"}
                                        variant="outlined"
                                        id={"estado_id"}
                                        value={estadoEscolhido}
                                        onChange={(e) => {
                                            e.preventDefault();
                                            const estado = e.target.value as number;
                                            setEstadoEscolhido(estado);
                                            filtrarCidades(estado);
                                        }}
                                    >   
                                        <MenuItem key={-1} value={-1}>Todos</MenuItem>
                                        {comboEstados}
                                    </Select>
                                </FormControl>
                            </Grid>

                            <Grid item sm={12}>
                                <FormLabel className={classes.formControl} >Cidades</FormLabel>
                                <FormControl  margin='dense' fullWidth>
                                    <MultiSelect
                                        className={classes.formControl}
                                        options={transToSelect(cidades, 'id', 'nome')}
                                        isMulti
                                        placeholder='Todas cidades do estado'
                                        value={cidadesEscolhidas}
                                        onChange={(options) => {
                                            setCidadesEscolhidas(options);                                         
                                        }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item sm={12}>
                                <FormLabel className={classes.formControl}>Herbicida</FormLabel>
                                <FormControl margin='dense' fullWidth>
                                    <Select
                                        labelId={"herbicida_id"}
                                        className={classes.formControl}
                                        variant="outlined"
                                        id={"herbicida_id"}
                                        value={herbicidaEscolhido}
                                        onChange={(e) => {
                                            e.preventDefault();
                                            const herbicida = e.target.value as string;
                                            setHerbicidaEscolhido(herbicida);
                                        }}
                                    >
                                        <MenuItem key={"All"} value={"All"}>Todos</MenuItem>
                                        {comboHerbicidas}
                                    </Select>
                                </FormControl>
                            </Grid>      
                            <Grid item sm={12}>
                                <FormLabel className={classes.formControl}>Mecanismo de ação</FormLabel>
                                <FormControl margin='dense' fullWidth>
                                    <Select
                                        labelId={"mecanismo_acao_id"}
                                        className={classes.formControl}
                                        variant="outlined"
                                        disabled={respostaEscolhida!=='Resistant'}
                                        id={"mecanismo_acao_id"}
                                        value={mecanismoAcaoEscolhido}
                                        onChange={(e) => {
                                            e.preventDefault();
                                            const mecanismo = e.target.value as string;
                                            setMecanismoAcaoEscolhido(mecanismo);
                                        }}
                                    >
                                        <MenuItem key={"All"} value={"All"}>Todos</MenuItem>
                                        {comboMecanismosAcao}
                                    </Select>
                                </FormControl>
                            </Grid>                
                            <Grid item sm={12}>
                                <FormLabel className={classes.formControl}>Tipo de Resistência</FormLabel>
                                <FormControl margin='dense' fullWidth>
                                    <Select
                                        labelId={"multiplo_mecanismo_id"}
                                        className={classes.formControl}
                                        variant="outlined"
                                        id={"multiplo_mecanismo_id"}
                                        value={multiploMecanismoEscolhido}
                                        onChange={(e) => {
                                            e.preventDefault();
                                            const multiplo = e.target.value as string;
                                            setMultiploMecanismoEscolhido(multiplo);
                                        }}
                                    >
                                        <MenuItem key={"All"} value={"All"}>Todos</MenuItem>
                                        {comboMultiplosMecanismos}
                                    </Select>
                                </FormControl>
                            </Grid>                        
                        </Grid>

                </div>

            </Paper>
            <Divider light />
            <Grid container justify='center'>
                <Button
                    className={classes.button}
                    variant='contained'
                    color='primary'
                    onClick={() => aplicarConsulta()}
                    startIcon={<FilterListIcon />}
                >
                    Aplicar
                </Button>

            </Grid>

        </>
    );
}